module.exports = "/packs/001-fd9b889483060b160343291e233bd049.jpg";